import React from "react";

import StyledLoaderContainer from "./style";

const LoaderPage = () => {
	return (
		<StyledLoaderContainer>
			<div className="loader"></div>
		</StyledLoaderContainer>
	);
};

export default LoaderPage;
